var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("账号密码校验")
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.accountForm,
      rules: _vm.rules,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("账号")
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.accountInfo.account))])]), _vm.activeKey === "1" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("密码"),
      prop: "password"
    }
  }, [_c("a-input-password", {
    ref: "password",
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("密码"),
      size: "large",
      "allow-clear": "",
      maxLength: 30
    },
    on: {
      input: function ($event) {
        _vm.accountForm.password = _vm.accountForm.password.replace(/\s/g, "");
      }
    },
    model: {
      value: _vm.accountForm.password,
      callback: function ($$v) {
        _vm.$set(_vm.accountForm, "password", $$v);
      },
      expression: "accountForm.password"
    }
  }, [_c("svg-icon", {
    attrs: {
      slot: "prefix",
      icon: "password",
      size: 14
    },
    slot: "prefix"
  })], 1)], 1) : _vm._e()], 1)], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("手机验证码校验")
    }
  }, [_c("a-form-model", {
    ref: "mobileRuleForm",
    attrs: {
      model: _vm.mobileForm,
      rules: _vm.rules,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号")
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.accountInfo.globalRoaming) + " " + _vm._s(_vm.encryMobile))])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("验证码"),
      prop: "code"
    }
  }, [_c("a-input", {
    ref: "code",
    staticStyle: {
      width: "65%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("验证码"),
      maxLength: 6
    },
    on: {
      input: function ($event) {
        return _vm.codeInput("code", $event);
      },
      blur: function ($event) {
        return _vm.handleBlurTrim("code", $event);
      }
    },
    model: {
      value: _vm.mobileForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.mobileForm, "code", $$v);
      },
      expression: "mobileForm.code"
    }
  }), _vm.textLength > 9 ? _c("a-tooltip", {
    attrs: {
      placement: "topRight"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.text)))])]), _c("a-button", {
    staticClass: "codeBtn",
    attrs: {
      size: "small",
      disabled: _vm.disable
    },
    on: {
      click: _vm.getCode
    }
  }, [_c("span", {
    staticClass: "codeText"
  }, [_vm._v(_vm._s(_vm.$t(_vm.text)))])])], 2) : _c("a-button", {
    staticClass: "codeBtn",
    attrs: {
      size: "small",
      disabled: _vm.disable
    },
    on: {
      click: _vm.getCode
    }
  }, [_c("span", {
    staticClass: "codeText"
  }, [_vm._v(_vm._s(_vm.$t(_vm.text)))])])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };